<template>
  <div id="introductory">
    <Head />
    <div class="main">
      <div class="position">
        <img src="../../assets/public/8.png" /> 当前位置:
        <router-link to="/">首页</router-link>>
        <router-link to="/#biaogan">标杆企业</router-link>>企业简介
      </div>
      <h3>企业简介</h3>
      <div class="container">
        <div class="left-box">
          <div class="title">
            <img src="../../assets/Index/s2.png" alt />企业简介
          </div>
          <ul>
            <li :class="{active : navI == 0}" @click="getNav(0)">山东能源淄博矿业集团有限公司</li>
            <li :class="{active : navI == 1}" @click="getNav(1)">山东能源集团有限公司</li>
            <li :class="{active : navI == 2}" @click="getNav(2)">义马煤业集团股份有限公司</li>
          </ul>
        </div>
        <div class="right-box">
          <ul>
            <li v-for="(item,index) in list[navI] " :key="index">
              <img :src="item.src" alt />
              <div class="rightContainer">
                <p class="title">{{item.Title}}</p>
                <p class="container">{{item.duan1}}</p>
                <p class="container">{{item.duan2}}</p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <Foot />
  </div>
</template>

<script>
import Head from "../../components/Head";
import Foot from "../../components/Foot";
export default {
  name: "introductory",
  components: {
    Head,
    Foot
  },
  data() {
    return {
      navI: 0,
      list: [
        [
          {
            Title: "山东能源淄博矿业集团有限公司",
            src: require("../../assets/Index/zikuang.jpg"),
            duan1:
              "淄矿集团是山东能源集团权属企业之一，经营范围涉及煤炭、医疗健康、建材、新材料等多个产业，主要生产经营单位分布在鲁、陕、蒙、甘四省区的淄博、济南、济宁、咸阳、鄂尔多斯、平凉市等六个地市。总部坐落在聊斋故里淄博市淄川区，现有职工1.6万多人。",
            duan2:
              "淄博矿区煤炭开采历史悠久，文化底蕴丰厚，是我国近代工业的发祥地之一，也是我党早期开展工人运动的地区之一，自1904年德国人开凿建立淄川煤矿、进入规模化开采以来，至今已有一百多年的开采历史。1953年建局以来，已累计产煤4亿多吨，煤炭产量曾连续多年占到全省总产量的一半以上，为国民经济发展作出了重要贡献。同时，也为国家培养和输送了一大批优秀人才，先后成建制向行业内外调出职工14000多人、管理干部4600多人，有力地支援了国家和地方建设。先后涌现出11个全国先进集体、16名全国劳动模范，诞生了全国煤炭系统十面旗帜之一“五四”采煤队、被誉为“救护铁军”的淄矿救护大队等一大批闻名全国的先进典型。在不同的历史时期，淄矿先后荣获“大庆式企业”、全国五一劳动奖状、全国煤炭行业优秀企业、省级文明单位、山东60年60品牌等殊荣。自1986年开始，连续保持了“全国思想政治工作先进单位”荣誉称号。"
          }
        ],
        [
          {
            Title: "山东能源集团有限限公司",
            src: require("../../assets/Index/banner-lm-1.jpg"),
            duan1:
              "山东能源集团是省委、省政府整合重组省内6家煤炭公司组建的省属大型能源企业。2011年3月成立，2015年8月改建为国有资本投资公司。目前，注册资本170亿元，资产总额、营业收入突破3000亿元，拥有煤炭资源总量446亿吨，内外部煤炭产量连续8年过亿吨，参控股电力装机10210MW，煤制天然气20亿立方米，拟建海陆风电项目装机600MW，产业遍布国内16个省（区）、境外5个国家（地区）。现有员工15.9万人，是我省经济规模最大、从业人员最多、党员人数最多的国有企业，已发展成为全国第二大优质炼焦煤供应商、华东第一大清洁高效煤炭供应商、山东省内产量最大的煤炭企业。",
            duan2:
              "近年来，能源集团坚持以习近平新时代中国特色社会主义思想为指导，认真贯彻省委、省政府决策部署，坚定践行新发展理念，持续走安全、创新、绿色发展之路，瞄准实力、价值、活力、和谐“四新山能”愿景目标，聚力发展煤炭及相关产业、电力及新能源、化工及新材料、医养健康“四大主业”，构建“3+5”八强产业体系，形成内外并举的“1+4+2”区域布局，传统产业加快改造提升，新产业新动能培育壮大，“四新”经济收入同比提高7.43%，初步实现由规模速度型向高质量发展、由传统能源向传统能源与新兴能源并举、由单一煤炭生产供应商向综合能源服务商“三个转变”。2016年以来，营业收入、利润总额、净利润、社会贡献总额、上缴税费等指标持续位居省属企业首位。连续3年超额完成省国资委经营业绩考核目标，考核结果处于优秀等级。连续八年跻身世界500强，2019年位居211位。集团总部连续4年保持“全国文明单位”称号。"
          }
        ],
        [
          {
            Title: "义马煤业集团股份有限公司",
            src: require("../../assets/Index/yimei.jpg"),
            duan1:
              "义马煤业集团股份有限公司是国有特大型煤炭企业，原为义马矿务局，现有职工5万余人，截至2012年底资产总额590多亿元，矿区地跨河南、青海、新疆、山西、内蒙古等五省（区），拥有生产矿井16座，原煤产能3400多万吨，所产焦煤、贫瘦煤、无烟煤和洗精煤广泛应用于发电、造气、工业锅炉、炼焦和建材等行业，产品广销国内20多个省区，同时还涉足制造、发电、水泥、氧化铝、煤化工等领域。先后被评为河南省最具影响力企业、河南省省管企业先进企业党委、河南省思想政治工作先进企业、中国节能减排功勋企业、中国安全文化典范企业等，荣获全国五一劳动奖状，位列2012中国企业500强第283位。"
          }
        ]
      ]
    };
  },
  methods: {
    getNav(i) {
      console.log(i);
      this.navI = i;
    }
  }
};
</script>

<style lang="less" scope>
#introductory {
  font-size: 0.16rem;
  width: 100%;
  min-width: 1000px;
  .main {
    padding: 0 1.35rem;
    margin-top: 0.4rem;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #282828;
    .container {
      display: flex;
      justify-content: space-between;
      .left-box {
        width: 3.5rem;
        border: 0.01rem solid #ababab;
        margin-bottom: 0.3rem;
        height: 2.8rem;
        .title {
          font-size: 0.2rem;
          width: 100%;
          height: 0.64rem;
          padding: 0.17rem 0.21rem;
          background: #3f6bc2;
          color: #fff;
          line-height: 0.64rem;
          display: flex;
          align-items: center;
          img {
            width: 0.3rem;
            height: 0.3rem;
            margin-right: 0.2rem;
          }
        }
        > ul {
          margin-top: 0.05rem;
          .active {
            background: #84c7fa;
            color: #fff;
          }
          > li {
            border-bottom: 1px solid #bababa;
            padding: 0.17rem;
            cursor: pointer;
          }

          > li:last-child {
            margin-bottom: 1rem;
          }
        }
      }
      .right-box {
        width: 12.41rem;
        padding: 0.38rem 0.34rem 0 0.28rem;
        border: 0.01rem solid #ababab;
        ul {
          width: 100%;
          li {
            img {
              width: 100%;
              height: 3.68rem;
            }
            .rightContainer {
              margin-top: 0.38rem;
              line-height: 0.3rem;
              padding:.01rem  0 ;
              .title {
                text-align: center;
                font-weight: 700;
                font-size: 0.36rem;
                margin-bottom: 0.25rem;
              }
              .container {
                color: #333;
                text-indent: 2em;
                font-size: 0.18rem;
                padding: 0.15rem 0;
              }
            }
          }
        }
      }
    }
    h3 {
      margin-bottom: 0.5rem;
      padding-top: 0.52rem;
      padding-left: 4rem;
      font-size: 0.3rem;
      text-align: center;
    }
    .position {
      display: flex;
      align-items: center;
      padding: 0.1rem;
      background: #f1f1f1;
      color: #2f4f73;
      img {
        width: 0.2rem;
        margin-right: 0.1rem;
      }
    }
  }
}
</style>